import { render } from "./EditPayment1.vue?vue&type=template&id=6d3f4a68"
import script from "./EditPayment1.vue?vue&type=script&lang=js"
export * from "./EditPayment1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__